// extracted by mini-css-extract-plugin
export var clearIcon = "fX_mJ";
export var dropdown = "fX_j4";
export var hasClearIcon = "fX_mH";
export var open = "fX_ks";
export var small = "fX_b7";